'use client';

import type { FC } from 'react';
import { Skeleton } from './ui';

export const CaseCardSkeleton: FC = () => {
  return (
    <div className="bg-white/5 rounded-2xl p-0 relative overflow-hidden aspect-square w-full">
      <Skeleton className="absolute inset-0 rounded-2xl" />

      <div className="absolute top-2 right-2 z-[1]">
        <Skeleton className="w-16 h-5 bg-black/30 rounded-full" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-3 flex flex-col items-center gap-1 z-[1]">
        <Skeleton className="w-20 h-5 bg-black/30 rounded-full" />
        <Skeleton className="w-16 h-5 bg-black/30 rounded-full" />
      </div>
    </div>
  );
};
